import { render, staticRenderFns } from "./Entrega.vue?vue&type=template&id=2df60484&scoped=true"
import script from "./Entrega.vue?vue&type=script&lang=js"
export * from "./Entrega.vue?vue&type=script&lang=js"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "./Entrega.vue?vue&type=style&index=2&id=2df60484&prod&lang=css"
import style3 from "./Entrega.vue?vue&type=style&index=3&id=2df60484&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df60484",
  null
  
)

export default component.exports